// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ServiceType {
    MEDICALCARE = 'MEDICAL_CARE',
    SURGICAL = 'SURGICAL',
    CONSULTATION = 'CONSULTATION',
    DIAGNOSTICXRAY = 'DIAGNOSTIC_XRAY',
    DIAGNOSTICLAB = 'DIAGNOSTIC_LAB',
    RADIATIONTHERAPY = 'RADIATION_THERAPY',
    ANESTHESIA = 'ANESTHESIA',
    SURGICALASSISTANCE = 'SURGICAL_ASSISTANCE',
    OTHERMEDICAL = 'OTHER_MEDICAL',
    BLOODCHARGES = 'BLOOD_CHARGES',
    USEDDURABLEMEDICALEQUIPMENT = 'USED_DURABLE_MEDICAL_EQUIPMENT',
    DURABLEMEDICALEQUIPMENTPURCHASE = 'DURABLE_MEDICAL_EQUIPMENT_PURCHASE',
    AMBULATORYSERVICECENTERFACILITY = 'AMBULATORY_SERVICE_CENTER_FACILITY',
    RENALSUPPLIESINTHEHOME = 'RENAL_SUPPLIES_IN_THE_HOME',
    ALTERNATEMETHODDIALYSIS = 'ALTERNATE_METHOD_DIALYSIS',
    CHRONICRENALDISEASEEQUIPMENT = 'CHRONIC_RENAL_DISEASE_EQUIPMENT',
    PREADMISSIONTESTING = 'PRE_ADMISSION_TESTING',
    DURABLEMEDICALEQUIPMENTRENTAL = 'DURABLE_MEDICAL_EQUIPMENT_RENTAL',
    PNEUMONIAVACCINE = 'PNEUMONIA_VACCINE',
    SECONDSURGICALOPINION = 'SECOND_SURGICAL_OPINION',
    THIRDSURGICALOPINION = 'THIRD_SURGICAL_OPINION',
    SOCIALWORK = 'SOCIAL_WORK',
    DIAGNOSTICDENTAL = 'DIAGNOSTIC_DENTAL',
    PERIODONTICS = 'PERIODONTICS',
    RESTORATIVE = 'RESTORATIVE',
    ENDODONTICS = 'ENDODONTICS',
    MAXILLOFACIALPROSTHETICS = 'MAXILLOFACIAL_PROSTHETICS',
    ADJUNCTIVEDENTALSERVICES = 'ADJUNCTIVE_DENTAL_SERVICES',
    HEALTHBENEFITPLANCOVERAGE = 'HEALTH_BENEFIT_PLAN_COVERAGE',
    PLANWAITINGPERIOD = 'PLAN_WAITING_PERIOD',
    CHIROPRACTIC = 'CHIROPRACTIC',
    CHIROPRACTICOFFICEVISITS = 'CHIROPRACTIC_OFFICE_VISITS',
    DENTALCARE = 'DENTAL_CARE',
    DENTALCROWNS = 'DENTAL_CROWNS',
    DENTALACCIDENT = 'DENTAL_ACCIDENT',
    ORTHODONTICS = 'ORTHODONTICS',
    PROSTHODONTICS = 'PROSTHODONTICS',
    ORALSURGERY = 'ORAL_SURGERY',
    ROUTINEDENTAL = 'ROUTINE_DENTAL',
    HOMEHEALTHCARE = 'HOME_HEALTH_CARE',
    HOMEHEALTHPRESCRIPTIONS = 'HOME_HEALTH_PRESCRIPTIONS',
    HOMEHEALTHVISITS = 'HOME_HEALTH_VISITS',
    HOSPICE = 'HOSPICE',
    RESPITECARE = 'RESPITE_CARE',
    HOSPITAL = 'HOSPITAL',
    HOSPITALINPATIENT = 'HOSPITAL_INPATIENT',
    HOSPITALROOMANDBOARD = 'HOSPITAL_ROOM_AND_BOARD',
    HOSPITALOUTPATIENT = 'HOSPITAL_OUTPATIENT',
    HOSPITALEMERGENCYACCIDENT = 'HOSPITAL_EMERGENCY_ACCIDENT',
    HOSPITALEMERGENCYMEDICAL = 'HOSPITAL_EMERGENCY_MEDICAL',
    HOSPITALAMBULATORYSURGICAL = 'HOSPITAL_AMBULATORY_SURGICAL',
    LONGTERMCARE = 'LONG_TERM_CARE',
    MAJORMEDICAL = 'MAJOR_MEDICAL',
    MEDICALLYRELATEDTRANSPORTATION = 'MEDICALLY_RELATED_TRANSPORTATION',
    AIRTRANSPORTATION = 'AIR_TRANSPORTATION',
    CABULANCE = 'CABULANCE',
    LICENSEDAMBULANCE = 'LICENSED_AMBULANCE',
    GENERALBENEFITS = 'GENERAL_BENEFITS',
    INVITROFERTILIZATION = 'IN_VITRO_FERTILIZATION',
    MRICATSCAN = 'MRI_CAT_SCAN',
    DONORPROCEDURES = 'DONOR_PROCEDURES',
    ACUPUNCTURE = 'ACUPUNCTURE',
    NEWBORNCARE = 'NEWBORN_CARE',
    PATHOLOGY = 'PATHOLOGY',
    SMOKINGCESSATION = 'SMOKING_CESSATION',
    WELLBABYCARE = 'WELL_BABY_CARE',
    MATERNITY = 'MATERNITY',
    TRANSPLANTS = 'TRANSPLANTS',
    AUDIOLOGYEXAM = 'AUDIOLOGY_EXAM',
    INHALATIONTHERAPY = 'INHALATION_THERAPY',
    DIAGNOSTICMEDICAL = 'DIAGNOSTIC_MEDICAL',
    PRIVATEDUTYNURSING = 'PRIVATE_DUTY_NURSING',
    PROSTHETICDEVICE = 'PROSTHETIC_DEVICE',
    DIALYSIS = 'DIALYSIS',
    OTOLOGICALEXAM = 'OTOLOGICAL_EXAM',
    CHEMOTHERAPY = 'CHEMOTHERAPY',
    ALLERGYTESTING = 'ALLERGY_TESTING',
    IMMUNIZATIONS = 'IMMUNIZATIONS',
    ROUTINEPHYSICAL = 'ROUTINE_PHYSICAL',
    FAMILYPLANNING = 'FAMILY_PLANNING',
    INFERTILITY = 'INFERTILITY',
    ABORTION = 'ABORTION',
    AIDS = 'AIDS',
    EMERGENCYSERVICES = 'EMERGENCY_SERVICES',
    CANCER = 'CANCER',
    PHARMACY = 'PHARMACY',
    FREESTANDINGPRESCRIPTIONDRUG = 'FREE_STANDING_PRESCRIPTION_DRUG',
    MAILORDERPHARMACY = 'MAIL_ORDER_PHARMACY',
    BRANDNAMEPRESCRIPTIONDRUG = 'BRAND_NAME_PRESCRIPTION_DRUG',
    GENERICPRESCRIPTIONDRUG = 'GENERIC_PRESCRIPTION_DRUG',
    PODIATRY = 'PODIATRY',
    PODIATRYOFFICEVISITS = 'PODIATRY_OFFICE_VISITS',
    PODIATRYNURSINGHOMEVISITS = 'PODIATRY_NURSING_HOME_VISITS',
    PROFESSIONAL = 'PROFESSIONAL',
    ANESTHESIOLOGIST = 'ANESTHESIOLOGIST',
    PROFESSIONALVISITOFFICE = 'PROFESSIONAL_VISIT_OFFICE',
    PROFESSIONALVISITINPATIENT = 'PROFESSIONAL_VISIT_INPATIENT',
    PROFESSIONALVISITOUTPATIENT = 'PROFESSIONAL_VISIT_OUTPATIENT',
    PROFESSIONALVISITNURSINGHOME = 'PROFESSIONAL_VISIT_NURSING_HOME',
    PROFESSIONALVISITSKILLEDNURSINGFACILITY = 'PROFESSIONAL_VISIT_SKILLED_NURSING_FACILITY',
    PROFESSIONALVISITHOME = 'PROFESSIONAL_VISIT_HOME',
    PSYCHIATRIC = 'PSYCHIATRIC',
    PSYCHIATRICROOMANDBOARD = 'PSYCHIATRIC_ROOM_AND_BOARD',
    PSYCHOTHERAPY = 'PSYCHOTHERAPY',
    PSYCHIATRICINPATIENT = 'PSYCHIATRIC_INPATIENT',
    PSYCHIATRICOUTPATIENT = 'PSYCHIATRIC_OUTPATIENT',
    REHABILITATION = 'REHABILITATION',
    REHABILITATIONROOMANDBOARD = 'REHABILITATION_ROOM_AND_BOARD',
    REHABILITATIONINPATIENT = 'REHABILITATION_INPATIENT',
    REHABILITATIONOUTPATIENT = 'REHABILITATION_OUTPATIENT',
    OCCUPATIONALTHERAPY = 'OCCUPATIONAL_THERAPY',
    PHYSICALMEDICINE = 'PHYSICAL_MEDICINE',
    SPEECHTHERAPY = 'SPEECH_THERAPY',
    SKILLEDNURSINGCARE = 'SKILLED_NURSING_CARE',
    SKILLEDNURSINGCAREROOMANDBOARD = 'SKILLED_NURSING_CARE_ROOM_AND_BOARD',
    SUBSTANCEABUSE = 'SUBSTANCE_ABUSE',
    ALCOHOLISM = 'ALCOHOLISM',
    DRUGADDICTION = 'DRUG_ADDICTION',
    VISION = 'VISION',
    FRAMES = 'FRAMES',
    ROUTINEEXAM = 'ROUTINE_EXAM',
    LENSES = 'LENSES',
    ROUTINEEYEEXAM = 'ROUTINE_EYE_EXAM',
    NONMEDICALLYNECESSARYPHYSICAL = 'NONMEDICALLY_NECESSARY_PHYSICAL',
    EXPERIMENTALDRUGTHERAPY = 'EXPERIMENTAL_DRUG_THERAPY',
    BURNCARE = 'BURN_CARE',
    BRANDNAMEPRESCRIPTIONDRUGFORUMULARY = 'BRAND_NAME_PRESCRIPTION_DRUG_FORUMULARY',
    BRANDNAMEPRESCRIPTIONDRUGNONFORUMULARY = 'BRAND_NAME_PRESCRIPTION_DRUG_NON_FORUMULARY',
    INDEPENDENTMEDICALEVALUATION = 'INDEPENDENT_MEDICAL_EVALUATION',
    PARTIALHOSPITALIZATIONPSYCHIATRIC = 'PARTIAL_HOSPITALIZATION_PSYCHIATRIC',
    DAYCAREPSYCHIATRIC = 'DAY_CARE_PSYCHIATRIC',
    COGNITIVETHERAPY = 'COGNITIVE_THERAPY',
    MASSAGETHERAPY = 'MASSAGE_THERAPY',
    PULMONARYREHABILITATION = 'PULMONARY_REHABILITATION',
    CARDIACREHABILITATION = 'CARDIAC_REHABILITATION',
    PEDIATRIC = 'PEDIATRIC',
    NURSERY = 'NURSERY',
    SKIN = 'SKIN',
    ORTHOPEDIC = 'ORTHOPEDIC',
    CARDIAC = 'CARDIAC',
    LYMPHATIC = 'LYMPHATIC',
    GASTROINTESTINAL = 'GASTROINTESTINAL',
    ENDOCRINE = 'ENDOCRINE',
    NEUROLOGY = 'NEUROLOGY',
    EYE = 'EYE',
    INVASIVEPROCEDURES = 'INVASIVE_PROCEDURES',
    GYNECOLOGICAL = 'GYNECOLOGICAL',
    OBSTETRICAL = 'OBSTETRICAL',
    OBSTETRICALGYNECOLOGICAL = 'OBSTETRICAL_GYNECOLOGICAL',
    MAILORDERPRESCRIPTIONDRUGBRANDNAME = 'MAIL_ORDER_PRESCRIPTION_DRUG_BRAND_NAME',
    MAILORDERPRESCRIPTIONDRUGGENERIC = 'MAIL_ORDER_PRESCRIPTION_DRUG_GENERIC',
    PHYSICIANVISITOFFICESICK = 'PHYSICIAN_VISIT_OFFICE_SICK',
    PHYSICIANVISITOFFICEWELL = 'PHYSICIAN_VISIT_OFFICE_WELL',
    CORONARYCARE = 'CORONARY_CARE',
    PRIVATEDUTYNURSINGINPATIENT = 'PRIVATE_DUTY_NURSING_INPATIENT',
    PRIVATEDUTYNURSINGOUTPATIENT = 'PRIVATE_DUTY_NURSING_OUTPATIENT',
    SURGICALBENEFITSPROFESSIONAL = 'SURGICAL_BENEFITS_PROFESSIONAL',
    SURGICALBENEFITSFACILITY = 'SURGICAL_BENEFITS_FACILITY',
    MENTALHEALTHPROVIDERINPATIENT = 'MENTAL_HEALTH_PROVIDER_INPATIENT',
    MENTALHEALTHPROVIDEROUTPATIENT = 'MENTAL_HEALTH_PROVIDER_OUTPATIENT',
    MENTALHEALTHFACILITYINPATIENT = 'MENTAL_HEALTH_FACILITY_INPATIENT',
    MENTALHEALTHFACILITYOUTPATIENT = 'MENTAL_HEALTH_FACILITY_OUTPATIENT',
    SUBSTANCEABUSEFACILITYINPATIENT = 'SUBSTANCE_ABUSE_FACILITY_INPATIENT',
    SUBSTANCEABUSEFACILITYOUTPATIENT = 'SUBSTANCE_ABUSE_FACILITY_OUTPATIENT',
    SCREENINGXRAY = 'SCREENING_XRAY',
    SCREENINGLABORATORY = 'SCREENING_LABORATORY',
    MAMMOGRAMHIGHRISKPATIENT = 'MAMMOGRAM_HIGH_RISK_PATIENT',
    MAMMOGRAMLOWRISKPATIENT = 'MAMMOGRAM_LOW_RISK_PATIENT',
    FLUVACCINATION = 'FLU_VACCINATION',
    EYEWEARANDEYEWEARACESSORIES = 'EYEWEAR_AND_EYEWEAR_ACESSORIES',
    CASEMANAGEMENT = 'CASE_MANAGEMENT',
    DERMATOLOGY = 'DERMATOLOGY',
    DURABLEMEDICALEQUIPMENT = 'DURABLE_MEDICAL_EQUIPMENT',
    DIABETICSUPPLIES = 'DIABETIC_SUPPLIES',
    GENERICPRESCRIPTIONDRUGFORMULARY = 'GENERIC_PRESCRIPTION_DRUG_FORMULARY',
    GENERICPRESCRIPTIONDRUGNONFORUMULARY = 'GENERIC_PRESCRIPTION_DRUG_NON_FORUMULARY',
    ALLERGY = 'ALLERGY',
    INTENSIVECARE = 'INTENSIVE_CARE',
    MENTALHEALTH = 'MENTAL_HEALTH',
    NEONATALINTENSIVECARE = 'NEONATAL_INTENSIVE_CARE',
    ONCOLOGY = 'ONCOLOGY',
    POSITRONEMISSIONTOMOGRAPHYSCAN = 'POSITRON_EMISSION_TOMOGRAPHY_SCAN',
    PHYSICALTHERAPY = 'PHYSICAL_THERAPY',
    PULMONARY = 'PULMONARY',
    RENAL = 'RENAL',
    RESIDENTIALPSYCHIATRICTREATMENT = 'RESIDENTIAL_PSYCHIATRIC_TREATMENT',
    TRANSITIONALCARE = 'TRANSITIONAL_CARE',
    TRANSITIONALNURSERYCARE = 'TRANSITIONAL_NURSERY_CARE',
    URGENTCARE = 'URGENT_CARE',
    UNKNOWN = 'UNKNOWN'
}

export function ServiceTypeFromJSON(json: any): ServiceType {
    return json as ServiceType;
}

export function ServiceTypeToJSON(value?: ServiceType): any {
    return value as any;
}

